var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade confirmation-popup",
      attrs: { id: "userConsentPopup", role: "dialog" },
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog" },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header generic-header" }, [
              _vm._v(" Email Preferences "),
            ]),
            _c(
              "div",
              { staticClass: "modal-body pt-0" },
              [
                _c("div", { staticClass: "modal-note mb-15" }, [
                  _vm._v(
                    " Please update your email preference below. Email communication helps us keep you informed. "
                  ),
                ]),
                _vm.optInType === "single"
                  ? [
                      _c("div", { staticClass: "d-flex mb-15" }, [
                        _c("span", { staticClass: "checkbox" }, [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.emailOptin,
                                  expression: "emailOptin",
                                },
                              ],
                              attrs: { type: "checkbox", name: "terms-ul" },
                              domProps: {
                                checked: Array.isArray(_vm.emailOptin)
                                  ? _vm._i(_vm.emailOptin, null) > -1
                                  : _vm.emailOptin,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.emailOptin,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.emailOptin = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.emailOptin = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.emailOptin = $$c
                                  }
                                },
                              },
                            }),
                            _c("span", { staticClass: "cr" }),
                          ]),
                        ]),
                        _vm._m(0),
                      ]),
                    ]
                  : _vm.optInType === "pipl"
                  ? [
                      _c("div", { staticClass: "d-flex mb-15" }, [
                        _c("span", { staticClass: "checkbox" }, [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.emailOptin,
                                  expression: "emailOptin",
                                },
                              ],
                              attrs: { type: "checkbox", name: "terms-ul" },
                              domProps: {
                                checked: Array.isArray(_vm.emailOptin)
                                  ? _vm._i(_vm.emailOptin, null) > -1
                                  : _vm.emailOptin,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.emailOptin,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.emailOptin = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.emailOptin = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.emailOptin = $$c
                                  }
                                },
                              },
                            }),
                            _c("span", { staticClass: "cr" }),
                          ]),
                        ]),
                        _vm._m(1),
                      ]),
                      _c("div", { staticClass: "d-flex mb-15" }, [
                        _c("span", { staticClass: "checkbox" }, [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.dataConsent,
                                  expression: "dataConsent",
                                },
                              ],
                              attrs: {
                                type: "checkbox",
                                name: "terms-private",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.dataConsent)
                                  ? _vm._i(_vm.dataConsent, null) > -1
                                  : _vm.dataConsent,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.dataConsent,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.dataConsent = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.dataConsent = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.dataConsent = $$c
                                  }
                                },
                              },
                            }),
                            _c("span", { staticClass: "cr" }),
                          ]),
                        ]),
                        _vm._m(2),
                      ]),
                    ]
                  : _vm.optInType === "double"
                  ? [
                      _vm._m(3),
                      _c("div", { staticClass: "d-flex mb-15" }, [
                        _c("span", { staticClass: "checkbox" }, [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.emailOptin,
                                  expression: "emailOptin",
                                },
                              ],
                              attrs: {
                                type: "checkbox",
                                name: "terms-private",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.emailOptin)
                                  ? _vm._i(_vm.emailOptin, null) > -1
                                  : _vm.emailOptin,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.emailOptin,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.emailOptin = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.emailOptin = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.emailOptin = $$c
                                  }
                                },
                              },
                            }),
                            _c("span", { staticClass: "cr" }),
                          ]),
                        ]),
                        _vm._m(4),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _c("div", { staticClass: "modal-footer" }, [
              _c("div", { staticClass: "text-center" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn emergo-white-button",
                    class: { "hide-btn": !_vm.showUserConsentNeverBtn },
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.updateConsent("N")
                      },
                    },
                  },
                  [_vm._v(" Never ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn emergo-blue-button pr-40 pl-40",
                    attrs: { type: "button", disabled: _vm.disableSubmit },
                    on: {
                      click: function ($event) {
                        return _vm.updateConsent("Y")
                      },
                    },
                  },
                  [_vm._v(" Submit ")]
                ),
              ]),
              _c("div", { staticClass: "text-center pt-20" }, [
                _c(
                  "span",
                  {
                    staticClass: "skip-text",
                    on: {
                      click: function ($event) {
                        return _vm.updateConsent("P")
                      },
                    },
                  },
                  [
                    _c(
                      "base-tooltip",
                      {
                        attrs: {
                          content: "you will get a reminder post 30 days.",
                          placement: "top",
                        },
                      },
                      [_vm._v("Skip for now")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "terms-conditions ml-15", attrs: { for: "terms" } },
      [
        _vm._v(" By submitting this form, I agree to "),
        _c(
          "a",
          {
            staticClass: "term-priv",
            attrs: {
              href: "https://www.ul.com/resources/online-policies",
              target: "_blank",
            },
          },
          [_vm._v("Emergo by UL's Online Policies")]
        ),
        _vm._v(
          " and agree to receive periodic emails from Emergo by UL containing best practices, education, industry research, news, updates and promotions related to Emergo by UL's products and services. I understand that I can unsubscribe at any time by visiting our "
        ),
        _c(
          "a",
          {
            staticClass: "term-priv",
            attrs: { href: "https://www.ul.com/preference-center" },
          },
          [_vm._v("Preference Center")]
        ),
        _vm._v(". "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "terms-conditions ml-15", attrs: { for: "terms" } },
      [
        _vm._v(" By clicking this checkbox, I agree to "),
        _c(
          "a",
          {
            staticClass: "term-priv",
            attrs: {
              href: "https://www.ul.com/resources/online-policies",
              target: "_blank",
            },
          },
          [_vm._v("Emergo by UL's Online Policies")]
        ),
        _vm._v(
          " and agree to receive periodic emails from Emergo by UL containing best practices, education, industry research, news, updates and promotions related to Emergo by UL's products and services. I understand that I can unsubscribe at any time by visiting our "
        ),
        _c(
          "a",
          {
            staticClass: "term-priv",
            attrs: { href: "https://www.ul.com/preference-center" },
          },
          [_vm._v("Preference Center")]
        ),
        _vm._v(". "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "terms-conditions ml-15", attrs: { for: "terms" } },
      [
        _vm._v(
          " By clicking this checkbox, I agree Emergo by UL may process my personal information in accordance with the "
        ),
        _c(
          "a",
          {
            staticClass: "term-priv",
            attrs: {
              href: "https://www.ul.com/resources/online-policies",
              target: "_blank",
            },
          },
          [_vm._v("Emergo by UL's Online Policies")]
        ),
        _vm._v(
          " and to the cross-border transfer of my personal information to the United States. "
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex mb-15" }, [
      _c("div", { staticClass: "terms-conditions", attrs: { for: "terms" } }, [
        _vm._v(" By submitting this form, I agree to "),
        _c(
          "a",
          {
            staticClass: "term-priv",
            attrs: {
              href: "https://www.ul.com/resources/online-policies",
              target: "_blank",
            },
          },
          [_vm._v("Emergo by UL's Online Policies.")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "terms-conditions ml-15", attrs: { for: "terms" } },
      [
        _vm._v(
          " I would like to receive periodic emails from Emergo by UL containing best practices, education, industry research, news, updates and promotions related to Emergo by UL's products and services. I understand that I can unsubscribe at any time by visiting our "
        ),
        _c(
          "a",
          {
            staticClass: "term-priv",
            attrs: { href: "https://www.ul.com/preference-center" },
          },
          [_vm._v("Preference Center")]
        ),
        _vm._v(". "),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }